export default "__VITE_ASSET__C_Z5oig___"